<div class="divine-service-home-page" *ngIf="!isLoading && service; else loading">

  <!-- Header -->
  <app-divine-service-header
    [service]="service"
    [unitId]="unitId"
    [totalAdults]="summaryAdults"
    [totalMinors]="summaryMinors"
    (back)="goBack()"
    (edit)="editService()"
    (delete)="deleteService()"
    (closeAttendance)="closeAttendance()"
    (attendanceDetail)="openAttendanceTotals()"
    (goToList)="goToServiceList()">
  </app-divine-service-header>

  <!-- Content -->
  <div class="ds-content">
    <div *ngIf="(state$ | async)?.isLoading" class="loading-state">
      <mat-spinner diameter="48"></mat-spinner>
    </div>

    <ng-container *ngIf="!((state$ | async)?.isLoading)">
      <div class="desktop-service-sections">
        <mat-accordion *ngIf="hasMoreInformation" class="ds-sections ds-sections--desktop">
          <mat-expansion-panel class="ds-section-panel more-info-section">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>info_outline</mat-icon>
                Más información
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngTemplateOutlet="moreInformationContent"></ng-container>
          </mat-expansion-panel>
        </mat-accordion>

        <p *ngIf="service.isClosed" class="closed-notice">
          Concurrencia cerrada. Los datos historicos ya no se pueden modificar.
        </p>

        <main class="attendance-workspace">
          <ng-container *ngTemplateOutlet="attendanceContent"></ng-container>
        </main>
      </div>

      <mat-accordion class="ds-sections ds-sections--mobile" multi>
      <mat-expansion-panel class="ds-section-panel attendance-section" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>groups</mat-icon>
            Concurrencia
          </mat-panel-title>
        </mat-expansion-panel-header>

        <p *ngIf="service.isClosed" class="closed-notice">
          Concurrencia cerrada. Los datos historicos ya no se pueden modificar.
        </p>

        <main class="attendance-workspace">
          <ng-container *ngTemplateOutlet="attendanceContent"></ng-container>
        </main>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="hasMoreInformation" class="ds-section-panel more-info-section">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>info_outline</mat-icon>
            Más información
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-container *ngTemplateOutlet="moreInformationContent"></ng-container>
      </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
  </div>
</div>

<ng-template #attendanceContent>
  <app-attendance
    [members]="members"
    [isLoading]="((state$ | async)?.isLoading) ?? false"
    [isSaving]="((state$ | async)?.isSaving) ?? false"
    [readonly]="service?.isClosed === true"
    [divineServiceId]="serviceId"
    (membersUpdated)="onMembersUpdated($event)"
    (attendanceTotalsChanged)="onAttendanceTotalsChanged($event)">
  </app-attendance>
</ng-template>

<ng-template #moreInformationContent>
  <div class="extra-info" *ngIf="service">
    <div class="data-row" *ngIf="service.memberInCharge">
      <span class="data-label"><mat-icon>person</mat-icon> Siervo Responsable</span>
      <span class="data-value">{{ service.memberInCharge }}</span>
    </div>
    <div class="data-row" *ngIf="service.location">
      <span class="data-label"><mat-icon>location_on</mat-icon> Lugar</span>
      <span class="data-value">{{ service.location }}</span>
    </div>
    <div class="data-row" *ngIf="service.offeringsARS > 0 || service.offeringsUSD > 0">
      <span class="data-label"><mat-icon>volunteer_activism</mat-icon> Ofrendas</span>
      <span class="data-value">
        <span *ngIf="service.offeringsARS > 0">{{ service.offeringsARS | number:'1.2-2' }} ARS</span>
        <span *ngIf="service.offeringsARS > 0 && service.offeringsUSD > 0"> &bull; </span>
        <span *ngIf="service.offeringsUSD > 0">{{ service.offeringsUSD | number:'1.2-2' }} USD</span>
      </span>
    </div>
  </div>

  <div class="notes-section" *ngIf="service?.notes">
    <div class="notes-label">
      <mat-icon>notes</mat-icon>
      <span>Notas</span>
    </div>
    <div class="notes-content">{{ service?.notes }}</div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loading-state" *ngIf="isLoading">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
  <div class="empty-state" *ngIf="!isLoading">
    <mat-icon>info</mat-icon>
    <p>No hay servicio divino para mostrar</p>
  </div>
</ng-template>
